import React from 'react'

class Horline extends React.Component{
    render(){
        return(
            <div className="c_horline"></div>
        )
    }
}

export default Horline